module.exports = __webpack_public_path__ + "img/hide-black.2297a9e0.svg";